import { ReactNode } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { authChecker } from "src/utils/authCheck";

const adminRoute = [
  "/admin",
  "/admin/processing-management",
  "/admin/card-request",
  "/admin/transaction-History",
  "/admin/new-supplier",
  "/profile",
  "/admin/new-processing",
  "/supplier/new-card",
  "/admin/rate-info",
  "/admin/transaction-history",
];

const processingRoute = [
  "/processing-team",
  "/profile",
  "/processing-team/new-card",
  "/processing-team/user-management",
];
const supplierRoute = [
  "/supplier",
  "/profile",
  "/supplier/new-card",
  "/supplier/rate-info",
  "/supplier/payment-info",
  "/supplier/verification-limit"
];

type RequireAuthProps = {
  protectedPath?: boolean;
  children?: ReactNode;
};

const ignoreDynamicPart = (route: string) => {
  if (route.includes("/admin/transaction-history")) {
    return "/admin/transaction-history";
  }
  return route;
};

const RequireAuth = ({ protectedPath, children }: RequireAuthProps) => {
  const location = useLocation();
  const params = useParams();
  const isAuthenticated = authChecker();
  let url = `/login/?redirectUrl=${location?.pathname}`;
  let isUserAllowedRoutes = false;

  let account = localStorage.getItem("account");
  let accountType;
  if (account) {
    accountType = JSON.parse(account).accountType;
  }

  if (isAuthenticated) {
    const normalizedLocation = ignoreDynamicPart(location.pathname);

    if (accountType === "admin") {
      isUserAllowedRoutes = adminRoute.includes(normalizedLocation);
    } else if (accountType === "processing team") {
      isUserAllowedRoutes = processingRoute.includes(normalizedLocation);
    } else if (accountType === "supplier") {
      isUserAllowedRoutes = supplierRoute.includes(normalizedLocation);
    }
  }

  if (!isUserAllowedRoutes) {
    url = "/unauthorized";
  }

  return (
    <div>
      {protectedPath ? (
        <>
          {isAuthenticated && isUserAllowedRoutes ? (
            children
          ) : (
            <Navigate replace to={url} />
          )}
        </>
      ) : (
        children
      )}
    </div>
  );
};

export default RequireAuth;
